import { createSlice } from "@reduxjs/toolkit";

import {
    setOutdatedAction,
    setUpdatedAction,
    setErroredEntitiesAction,
    unsetSelectedClassificationAction,
    replaceRaceConditionsAction,
} from "../actions/raceConditionsActions";

import {
    selectAllRaceConditionsSelector,
    selectErroredEntitiesSelector,
    selectOutdatedSelector,
    selectUpdatedSelector,
} from "../selectors/raceConditionsSelectors";

const getInitialState = () => ({
    outdated: [],
    updated: [],
    erroredEntities: [],
    unsetSelectedClassification: false,
});

export const slice = createSlice({
    name: "raceConditions",
    initialState: getInitialState(),
    reducers: {
        setOutdated: setOutdatedAction,
        setUpdated: setUpdatedAction,
        setErroredEntities: setErroredEntitiesAction,
        setUnsetSelectedClassification: unsetSelectedClassificationAction,
        replaceRaceConditions: replaceRaceConditionsAction,
    },
});

// actions;
export const {
    setOutdated,
    setUpdated,
    setErroredEntities,
    setUnsetSelectedClassification,
    replaceRaceConditions,
} = slice.actions;

// selectors
// getRaceConditions
export const selectAllRaceConditions = (state) =>
    selectAllRaceConditionsSelector(state);

// getErroredEntities
export const selectErroredEntities = (state) =>
    selectErroredEntitiesSelector(state);

// getOutdated
export const selectOutdated = (state) => selectOutdatedSelector(state);

// getUpdated
export const selectUpdated = (state) => selectUpdatedSelector(state);

export default slice.reducer;
